import { render } from "./CRMPage.vue?vue&type=template&id=7aa9f465&ts=true"
import script from "./CRMPage.vue?vue&type=script&lang=ts"
export * from "./CRMPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__